import React from "react";
import { ShimmerCircle } from "../../../../Shimmer/ShimmerCircle/ShimmerCircle";
import { Stack } from "../../../../Stacks/Stack/Stack";
import { MediaShimmerSizes } from "../shared/styles";

export interface CircleShimmerColumnProps {
    /**
     * Icon props to create text elements.
     */
    readonly shimmerSize: MediaShimmerSizes;
}

export const CircleShimmerColumn: React.FC<CircleShimmerColumnProps> = ({
    shimmerSize
}) => {
    return (
        <Stack horizontal={true} verticalAlign="center">
            <Stack width={shimmerSize} margin="0 10px 0 0">
                <ShimmerCircle height={shimmerSize} />
            </Stack>
        </Stack>
    );
};
